import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
  // GA is initialised lazily (on first interaction / idle) AFTER the LCP window,
  // so TrackPageView's initial send fired before GA was ready. Send the landing
  // pageview here. Subsequent route changes are tracked by TrackPageView.
  try {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  } catch (e) {}
};
